const fontSize = {
  LARGE: "24px",
  MEDIUM: "18px",
  SMALL: "12px",
};

export { fontSize };
